import store from '@/store/store'
import { isArray } from 'lodash'
import { serialize } from 'object-to-formdata'
import Rest from '../Rest'

export default class ScheduleEventService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/schedule_events'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  findAllScheduleEvents(calendars: string, filters: any = {}) {
    // Construir query parameters
    const params = new URLSearchParams()

    // Adicionar calendários como query parameter (padronizado)
    if (calendars) {
      params.append('calendars', calendars)
    }

    // Adicionar filtros de data se fornecidos
    if (filters.startDate) {
      params.append('start_date', filters.startDate)
    }
    if (filters.endDate) {
      params.append('end_date', filters.endDate)
    }
    if (filters.year) {
      params.append('year', filters.year.toString())
    }
    if (filters.month) {
      params.append('month', filters.month.toString())
    }
    if (filters.day) {
      params.append('day', filters.day.toString())
    }

    // Adicionar filtro por autor se fornecido
    if (filters.author) {
      params.append('author', filters.author)
    }

    // Construir URL padronizada - todos os parâmetros como query string
    const queryString = params.toString()
    const url = queryString
      ? `find_all_by_calendar_type?${queryString}`
      : `find_all_by_calendar_type`

    return this.get(url).then(data => {
      return data
    })
  }

  getAttachments(scheduleEventId: any) {
    return this.get(`${scheduleEventId}/attachments`)
  }

  deleteAttachment(scheduleEventId: any, mediaId: any) {
    return this.delete(`${scheduleEventId}/attachment/${mediaId}`)
  }

  getInputData(payload) {
    const files = store.getters['calendar/inputFiles']
    if (isArray(files) && files.length > 0) {

      const form = serialize(payload, {indices: true, nullsAsUndefineds: true})

      files.forEach((file) => {
        form.append(`file[]`, file)
      })

      return form
    } else {
      return payload
    }
  }

  /**
   * @param {Object} record
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  create(record: any) {
    const input = this.getInputData(record)

    let contentType = 'application/json'
    if (input instanceof FormData) {
      contentType = 'multipart/form-data'
    }

    return this.post('', input, {
      'Content-Type': contentType
    })
  }

  /**
   * @param {Object} record
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  update(record: any) {
    const input = this.getInputData(record)

    let contentType = 'application/json'
    if (input instanceof FormData) {
      contentType = 'multipart/form-data'
    }

    return this.post(`/${this.getId(record)}`, input, {
      'Content-Type': contentType
    })
  }
}
